"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.6 15",
    width: "32.6",
    height: "15"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M5,15c-1.4,0-2.5-1.1-2.5-2.5S3.6,10,5,10s2.5,1.1,2.5,2.5S6.4,15,5,15z M5,11c-0.8,0-1.5,0.7-1.5,1.5 S4.2,14,5,14s1.5-0.7,1.5-1.5S5.8,11,5,11z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M26,15c-1.4,0-2.5-1.1-2.5-2.5S24.6,10,26,10s2.5,1.1,2.5,2.5S27.4,15,26,15z M26,11 c-0.8,0-1.5,0.7-1.5,1.5S25.2,14,26,14s1.5-0.7,1.5-1.5S26.8,11,26,11z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M21,15c-1.4,0-2.5-1.1-2.5-2.5S19.6,10,21,10s2.5,1.1,2.5,2.5S22.4,15,21,15z M21,11 c-0.8,0-1.5,0.7-1.5,1.5S20.2,14,21,14s1.5-0.7,1.5-1.5S21.8,11,21,11z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M18.8,13H7c-0.3,0-0.5-0.2-0.5-0.5S6.7,12,7,12h11.8c0.3,0,0.5,0.2,0.5,0.5S19,13,18.8,13z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M4.5,6C4.4,6,4.3,6,4.3,5.9C4,5.8,3.9,5.5,4.1,5.3l1.5-3C5.6,2.1,5.8,2,6,2h1.5C7.8,2,8,2.2,8,2.5 S7.8,3,7.5,3H6.3L4.9,5.7C4.9,5.9,4.7,6,4.5,6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M3,13H0.5C0.2,13,0,12.8,0,12.5V7c0-0.1,0.1-0.3,0.1-0.4l2-2l2.5-4.4C4.7,0.1,4.8,0,5,0h4.5 C9.8,0,10,0.2,10,0.5v10c0,0.3-0.2,0.5-0.5,0.5S9,10.8,9,10.5V1H5.3L2.9,5.2c0,0-0.1,0.1-0.1,0.1L1,7.2V12h2 c0.3,0,0.5,0.2,0.5,0.5S3.3,13,3,13z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M32.1,13h-3.7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h3.2v-1H0.5C0.2,11,0,10.8,0,10.5S0.2,10,0.5,10 h31.6c0.3,0,0.5,0.2,0.5,0.5v2C32.6,12.8,32.4,13,32.1,13z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "#EC6833",
    cx: "23.9",
    cy: "5.1",
    r: "4.3"
  }));
};

exports["default"] = _default;